module.exports = __webpack_public_path__ + "static/media/ceil.88ac1fcd.png";